import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

function Navbar() {
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="container">
        <div className="nav-content">
          <Link to="/" className="logo" onClick={closeMenu}>
            <img src="/logo.png" alt="Morning Light Funeral Services Logo" className="logo-image" />
          </Link>

          <button className="mobile-menu-toggle" onClick={toggleMenu} aria-label="Toggle menu">
            <span className={isMenuOpen ? 'open' : ''}></span>
            <span className={isMenuOpen ? 'open' : ''}></span>
            <span className={isMenuOpen ? 'open' : ''}></span>
          </button>

          <ul className={`nav-links ${isMenuOpen ? 'mobile-open' : ''}`}>
            <li><Link to="/" onClick={closeMenu}>Home</Link></li>
            {isHomePage && <li><a href="#pricing" onClick={closeMenu}>Pricing</a></li>}
            <li><Link to="/service-request" onClick={closeMenu}>Service Request</Link></li>
            {isHomePage && <li><a href="#about" onClick={closeMenu}>About</a></li>}
            {isHomePage && <li><a href="#contact" onClick={closeMenu}>Contact</a></li>}
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
